import { formatDate, filterEmptyParams } from "./utils"
import { config as sensorsConfig } from './sensors.client'
import { zeroToLocalZonetime } from './timezone'

const maxReconnectCount = 5 // 每轮计时重连次数
const reconnectInterval = 1 * 1000 // 每轮计时重连间隔
const LoopDuration = 30 * 1000
let reconnectCount = 0 // 当前轮计时重连次数
// useConnectStatus().value 当前连接状态
let worker: any = null

const blobURL = URL.createObjectURL(new Blob(
  [
    '(',

    function() {
      const intervalIds: IAnyObject = {}

      // 监听message 开始执行定时器或者销毁
      self.onmessage = function onMsgFunc(e) {
        const { command, data } = e.data

        switch (command) {
          case 'interval:start': // 开启定时器
            const intervalId = self.setInterval(() => {
              postMessage({
                message: 'interval:tick',
                id: data.id
              })
            }, data.interval || 200)

            postMessage({
              message: 'interval:started',
              id: data.id
            })

            intervalIds[data.id] = intervalId
            break
          case 'interval:clear': // 销毁
            self.clearInterval(intervalIds[data.id])

            postMessage({
              message: 'interval:cleared',
              id: data.id
            })

            delete intervalIds[data.id]
            break
        }
      }
    }.toString(),

    ')()'
  ],
  { type: 'application/javascript' }
))

export let socket: any = null
const msgTypeText: any = {
  2: '[Picture]',
  3: '[Goods message]',
  4: '[Order message]',
  5: '[Video]',
  7: '[Coupon message]'
}

const responseFn = (res: Msg.IMsgBase, fn: (res?: any) => void) => res.code === 200 ? fn(res?.data) : console.error(res.code, res.data)
const formatMessageContent = (content: string[]): Msg.IMsgContent => {
  const [ msgId, userId, msgType, msgText, msgStamp, userType, isView ] = content
  let msgContentSummary = msgText
  let msgContent: string | Msg.IMsgProduct | Msg.IMsgOrder = msgText
  if(msgType !== '1') {
    msgContentSummary = msgTypeText[msgType]
  }

  if(msgType === '3') {
    msgContent = JSON.parse(msgText) as Msg.IMsgProduct
  }

  if(msgType === '4') {
    msgContent = JSON.parse(msgText) as Msg.IMsgOrder
  }
  
  return {
    msgId,
    userId,
    msgDate: zeroToLocalZonetime(new Date(Number(msgStamp) * 1000), { format: 'yyyy-MM-dd hh:mm' }),
    msgType: Number(msgType),
    msgContent,
    msgContentSummary,
    msgStamp: Number(msgStamp),
    userType: Number(userType),
    isView: Number(isView)
  }
}

const initRoomList = async(fn?: () => void) => {
  socket.emit('room_list', { get_type: 'all', page: 1, page_size: 9999 }, (res: Msg.IMsgBase) => {  
    const list: Msg.IRoom[] = (res?.data || []).map((c: Msg.IRoom) => {
      if(c.last_message) {
        c.last_message_content = formatMessageContent(c.last_message)
      }
      
      return c
    })

    useRoomList().value = list

    fn && responseFn(res, fn)
  })
}
const handleRoom = () => {
  initRoomList(() => { console.info('-- initRoomList ok --') })

  socket.on('new_message', (res: any) => {
    const msgContent = formatMessageContent(res.data)

    if(useIsMobile().value) {
      useCurrentMsgList().value.push(msgContent)
    } else {
      const { room_id } = usePCCurrentChatRoom().value || {}
      
      if(!room_id) {
        return
      }

      if(!usePCRoomMsgList().value[room_id]) {
        usePCRoomMsgList().value[room_id] = []
      }

      usePCRoomMsgList().value[room_id].push(msgContent)

      const idx = useRoomList().value.findIndex((r: Msg.IRoom) => r.room_id === room_id)

      if(idx >=0) {
        const rom = useRoomList().value[idx]

        if(rom.last_message_content) {
          rom.last_message_content!.msgContentSummary = msgTypeText[msgContent.msgType] || msgContent.msgContentSummary
          useRoomList().value.splice(idx, 1)
          useRoomList().value.unshift(rom)
        } else {
          initRoomList(() => { console.info('-- initRoomList ok --') })
        }
      }
    }  
  })

  socket.on('new_room', (res: any) => {
    res.last_message_content = formatMessageContent(res.last_message)
    res.extra_info = res.room_info
    res.not_read_count = 1
    useMessageNotReadTotal().value += 1
    
    const idx = useRoomList().value.findIndex((r: Msg.IRoom) => r.room_id === res.room_id)

    if(idx >= 0) {
      const room = useRoomList().value[idx]
      res.not_read_count = room.not_read_count + 1

      useRoomList().value.splice(idx, 1)
      useRoomList().value.unshift(res)

      usePCRoomMsgList().value[room.room_id]?.push(formatMessageContent(res.last_message))
    } else {
      useRoomList().value.unshift(res)
    }
  })

  socket.emit('new_message_count', (res: any) => {
    if (res?.code === 200) {
      useMessageNotReadTotal().value = res?.data || 0
    }
  })
}

const displayMsgAsync = (roomId: string, lastMsgId: string) => {
  socket.emit('display', { room_id: roomId, message_id: lastMsgId })
}

const sortRoomList = (item: Msg.ISendMsg) => {
  const idx = useRoomList().value.findIndex((c: Msg.IRoom) => c.room_id === item.room_id)

  if(idx > 0) {
    const curRom = useRoomList().value[idx]
    curRom.last_message_content!.msgContentSummary = msgTypeText[item.message_type] || item.content

    useRoomList().value.splice(idx, 1)
    useRoomList().value.unshift(curRom)
  }
}

const joinRoom = (roomId: string, fn?: (res: any) => void) => {
  socket.emit('join', { room_id: roomId }, (res: any) => {
    const curRoom = useRoomList().value.find((c: Msg.IRoom) => c.room_id === roomId)
    if(curRoom){
      useMessageNotReadTotal().value -= curRoom.not_read_count

      curRoom.not_read_count = 0
    }

    fn && responseFn(res, fn)
  })
}

const createRoom = (storeInfo: Msg.IStoreInfo, fn?: (res: { id: string, extra_info: Msg.IExtraInfo }) => void) => {
  const { userId, phone, nick } = useUserInfo().value

  const params: Msg.IRoomInfo = {
    chat_type: '1:2',
    target_id: storeInfo.store_id,
    store_info: storeInfo,
    user_info: {
      user_id: userId,
      user_name: phone || nick,
      user_icon: 'https://image.kilimall.com/kenya/PcImages/message/icon_user_header.png'
    }
  }
  
  socket.emit('room_info', params, async(res: any) => {
    initRoomList(() => { 
      console.info('-- initRoomList ok --')

      fn && responseFn(res, fn)
    })
  })
}

const exitRoomAsync = (roomId: string, fn?: (res:any) => void) => {
  socket.emit('leave', { room_id: roomId }, (res: any) => {
    fn && responseFn(res, fn)
  })
}

const messageAfter = (params: any, fn?: (res: any) => void) => {
  socket.emit('message_after', params, (res: any) => {
    res.data = (res?.data || []).map((c: any)=> formatMessageContent(c))

    fn && responseFn(res, fn)
  })
}

const messageBefore = (params: any, fn?: (res: any) => void) => {
  socket.emit('message_before', params, (res: any) => {
    res.data = (res?.data || []).map((c: any)=> formatMessageContent(c))

    fn && responseFn(res, fn)
  })
}

const sendMsgAsync = (msg: Msg.ISendMsg, callback?: (res: any) => void) => {
  socket.emit('message', msg, (res: any) => {
    callback && callback(res)
  })
}

const initError = (NuxtApp: any) => {
  // 链接中断
  socket.on('disconnect', (e: any) => {
    useConnectStatus().value = 'disconnect'
    
    console.error("🚀 ~ socket.io.on ~ e:", e, useConnectStatus().value)
    socketReconnect(NuxtApp)
  })

  socket.on('reconnecting', (res: any) => {
    useConnectStatus().value = 'reconnecting'

    console.info("🚀 ~ socket.io.on ~ reconnecting:", res, useConnectStatus().value)
  })
  // 重连失败
  socket.on('reconnect_failed', (res: any) => {
    useConnectStatus().value = 'reconnect_failed'

    console.info("🚀 ~ socket.io.on ~ res:", res, useConnectStatus().value)

    socketReconnect(NuxtApp)
  })
  // 重连成功
  socket.on('reconnect', (res: any) => {
    useConnectStatus().value = 'success'

    console.info("🚀 ~ socket.io.on ~ reconnect:", res, useConnectStatus().value)
  })

  socket.on('connect_error', (res: any) => {
    // 商家,  跳转登陆重新获取token
    console.info('connect_error: ', res)

    useConnectStatus().value = 'connect_error'
  })
}

export const createSocket = (NuxtApp: any) => {
  const token: string = useUserInfo().value?.accessToken as string

  if(socket) {
    return
  }

  const anId = useCookie('anonymous-id').value
  const defaultConfig = token ? { type: 1, token } : { type: 0, token: anId }
  
  socket = NuxtApp.$nuxtSocket({
    withCredentials: true,
    transports: ['websocket'],
    // 如果沒有登录，则创建 匿名 链接
    query: filterEmptyParams({ ...defaultConfig, ...sensorsConfig.customEventCommonAttr }, true)
  })
  
  socket.connect()
  
  initError(NuxtApp)

  socket.on('connect', async () => {
    useConnectStatus().value = 'success'
    console.info('-- connectStatus success --')

    if(defaultConfig.type === 1) {
      console.info('-- Init room list --')
      await handleRoom()
    }

    setTimeout(() => initKeepActive(NuxtApp), 200)
  })
}

const clearSocket = () => {
  socket && socket.disconnect()
  socket = null
}

const socketReconnect = (NuxtApp: any) => {
  if(!useUserInfo().value?.accessToken) {
    return console.info('Socket reconnect error: Not accessToken!')
  }
  
  console.info("开始重连", reconnectCount)
  
  if(
    reconnectCount >= maxReconnectCount
      || ['reconnecting', 'success'].includes(useConnectStatus().value)
  ) {
    console.info("正在重连或超出本轮最大重连数：", reconnectCount, useConnectStatus().value)
    return
  }

  reconnectCount ++
  useConnectStatus().value = 'reconnecting'

  setTimeout(() => {
    socket?.disconnect()
    socket = null

    createSocket(NuxtApp)
  }, reconnectInterval)
}

export const initKeepActive = (NuxtApp: any) => {
  if(worker) {
    return    
  }

  worker = new Worker(blobURL)
  worker.postMessage({
    command: 'interval:start',
    data: {
      interval: LoopDuration,
      id: 'message_worker_interval_task' 
    }
  })

  worker.onmessage = (e: any) => {
    if(e.data.id === 'message_worker_interval_task') {
      try {
        if(!socket || socket.disconnected === true) {
          useConnectStatus().value = 'disconnect'
          socketReconnect(NuxtApp)
        }

        socket.emit('system_message', {
          event_name: 'heartbeat',
          event_data: Date.now()
        }, (res: any) => {})
        
        reconnectCount = 0
      } catch(e) {
        console.error("socket.io 已被回收:", e)
        useConnectStatus().value = 'disconnect'
        socketReconnect(NuxtApp)
      }
    }
  }
}

export default defineNuxtPlugin(async(NuxtApp) => {
  // 再 sensors.client.ts 插件中创建 socket
  // 埋点 插件依赖 socket，并且需要等 sensors sdk 加载完成之后才能创建 socket
  if(!/\/pvHome/.test(useRoute().path)){
    createSocket(NuxtApp)
  }

  return {
    provide: {
      msgSocket: {
        createRoom,
        clearSocket,
        createSocket,
        formatMessageContent,
        socket,
        joinRoom,
        // exitRoom,
        messageAfter,
        messageBefore,
        sendMsgAsync,
        exitRoomAsync,
        displayMsgAsync,
        sortRoomList
      }
    }
  }
})
